// IsaretKutusu.js — ORTAK İŞARET KUTUSU — TEK KAYNAK (2 Eki 2026)
//
// 🔑 Serkan (2 Eki 2026): *"check box'lar küçük, biraz belirgin olsun — PAPER OFP'de de çok küçük"*.
// 🔴 ÖNCESİ (ölçüldü): dört yerde (PAPER OFP · ASSIGN'da yer görevi PILOTS · ASSIGN ekip tablosu · ATPL/MED kısıtları) kutu
//    bir METİN KARAKTERİYDİ (☐ / ☑) — yazı boyutunda, çerçevesiz, işaretli ile işaretsiz zor ayırt ediliyordu.
// Çerçeveli kare: işaretsiz → gri çerçeve, boş · işaretli → dolu renk + ✓. Renk işin anlamını taşıyabilir (ATPL/MED
// kısıtı amber). Durum `data-isaretli` ile okunur (test ve ekran okuyucu metni yanındaki etikettir).
export default function IsaretKutusu({ isaretli, renk = 'var(--accent)', boyut = 18 }) {
  return (
    <span data-testid="isaret-kutusu" data-isaretli={isaretli ? 'evet' : 'hayir'} aria-hidden="true"
      style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', flexShrink:0,
               width:boyut, height:boyut, boxSizing:'border-box', borderRadius:4,
               border:`2px solid ${isaretli ? renk : 'var(--t2)'}`, background: isaretli ? renk : 'transparent',
               color:'var(--bg)', fontSize:Math.round(boyut * 0.72), fontWeight:900, lineHeight:1 }}>
      {isaretli ? '✓' : ''}
    </span>
  );
}
